import { render, staticRenderFns } from "./op-detail.vue?vue&type=template&id=647bdb64&scoped=true"
import script from "./op-detail.vue?vue&type=script&lang=js"
export * from "./op-detail.vue?vue&type=script&lang=js"
import style0 from "./op-detail.vue?vue&type=style&index=0&id=647bdb64&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647bdb64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('647bdb64')) {
      api.createRecord('647bdb64', component.options)
    } else {
      api.reload('647bdb64', component.options)
    }
    module.hot.accept("./op-detail.vue?vue&type=template&id=647bdb64&scoped=true", function () {
      api.rerender('647bdb64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/academicMaterials/diglog/op-detail.vue"
export default component.exports